import { module } from "angular";
import { TokenService } from "./TokenService";

module("mmAuth").service("mmTokenService", TokenService);
